/* eslint-disable no-console */
/**
 * https://visawiki.trusted.visa.com/pages/viewpage.action?spaceKey=CA&title=Visa+as+a+SRCI+low+level+design+and+implementation+details
 */
import { HandlerEvent } from 'post-robot';
import fetchReq from 'communicator/utils/fetch';

async function sha256(message: string) {
  // encode as UTF-8
  const msgBuffer = new TextEncoder().encode(message);

  // hash the message
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);

  // convert ArrayBuffer to Array
  const hashArray = Array.from(new Uint8Array(hashBuffer));

  // convert bytes to hex string
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  return hashHex;
}

/**
 * @param {object} response
 * @param {string} network
 * @param {string} intentId
 * @param {string} baseRequestPayload
 * @param {string} apikey
 * @returns {object} response object
 */
const paymentData = async (
  event: HandlerEvent<{
    apikey: string;
    idTokens: string[];
    intentId?: string;
    network: string;
    payloadJWS: unknown;
    createIntentRequestStr: string;
  }>
) => {
  const paymentDataUri = '/wallet-services-web/src/payment/data';
  const baseRequestPayload = btoa(unescape(encodeURIComponent(event.data.createIntentRequestStr)));

  // const baseRequestPayload = await encryptData(event.data.createIntentRequestStr);

  // TODO: remove vsbFlow from query string in 24.08.00
  let url = `${paymentDataUri}?apikey=${event.data.apikey}&vsbFlow=true`;

  const cirs = await sha256(baseRequestPayload + event.data.apikey + event.data.intentId);

  console.log(`()()()()()()()() PAYMENT DATA API CALLED`);
  console.log(`  paymentData: ${url}`);
  console.log(`  cardBrand: ${event.data.network}`);
  console.log(`  createIntentRequestStr: ${baseRequestPayload}`);
  console.log(`  createIntentRequestStr: ${cirs}`);
  console.log(`  payloadJWS: ${event.data.payloadJWS}`);
  console.log(`  intentId: ${event.data.intentId}`);
  console.log(`()()()()()()()() PAYMENT DATA API CALLED - DONE`);

  const requestPayload = {
    cardBrand: event.data.network,
    createIntentRequestStr: baseRequestPayload,
    // createIntentRequestStr: cirs,
    intentId: '',
    payloadJWS: event.data.payloadJWS
    // vsbFlow: true // TODO: 24.08.00 spec change, not reflected in 24.07 linked spec
  };

  if (event.data.intentId) {
    requestPayload.intentId = event.data.intentId;
    url = `${url}&intentId=${event.data.intentId}`;
  }

  const headers = {
    Accept: 'application/json',
    Authorization: 'POP; ct="SRC_EMBEDDED_MESSAGE", mba="payloadJWS"',
    'Content-Type': 'application/json;charset=utf-8'
  };

  const options = {
    body: requestPayload,
    headers,
    method: 'POST',
    url
  };

  // @ts-ignore
  return await fetchReq(options);
};

export default paymentData;
